import React, { useEffect, useState } from "react";
import { api, formatRupiah, formatErr } from "../../lib/api";
import { toast } from "sonner";

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const load = () => api.get("/admin/orders").then(r => setOrders(r.data));
  useEffect(() => { load(); }, []);
  const updateStatus = async (id, status) => {
    try { await api.put(`/admin/orders/${id}`, { payment_status: status }); load(); toast.success("Status diperbarui"); }
    catch (err) { toast.error(formatErr(err.response?.data?.detail)); }
  };
  return (
    <div data-testid="admin-orders-page">
      <h1 className="font-serif text-4xl text-[#1A1728] mb-2">Pesanan</h1>
      <p className="text-[#5C5870] mb-8">{orders.length} pesanan</p>
      <div className="lumina-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F1EBFA]/40 text-[#5C5870] text-xs uppercase tracking-wider">
            <tr>
              <th className="text-left px-6 py-4">No.</th>
              <th className="text-left px-6 py-4">Customer</th>
              <th className="text-left px-6 py-4">Items</th>
              <th className="text-left px-6 py-4">Total</th>
              <th className="text-left px-6 py-4">Status</th>
              <th className="text-right px-6 py-4">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {orders.map(o => (
              <tr key={o.id} className="border-t border-[#E2DFED]" data-testid={`order-row-${o.id}`}>
                <td className="px-6 py-4 font-mono text-xs">{o.order_number}</td>
                <td className="px-6 py-4"><div className="font-medium">{o.customer_name}</div><div className="text-xs text-[#5C5870]">{o.customer_email}</div></td>
                <td className="px-6 py-4 text-[#5C5870] max-w-xs truncate">{o.items.map(i => i.title).join(", ")}</td>
                <td className="px-6 py-4 text-[#6B4BA3] font-semibold">{formatRupiah(o.total)}</td>
                <td className="px-6 py-4">
                  <span className={`px-3 py-1 rounded-full text-xs ${o.payment_status === "paid" ? "bg-green-100 text-green-700" : o.payment_status === "pending" ? "bg-yellow-100 text-yellow-700" : "bg-red-100 text-red-700"}`}>{o.payment_status}</span>
                </td>
                <td className="px-6 py-4 text-right">
                  <select value={o.payment_status} onChange={e => updateStatus(o.id, e.target.value)} className="text-xs border border-[#E2DFED] rounded-lg px-2 py-1" data-testid={`status-${o.id}`}>
                    <option value="pending">pending</option>
                    <option value="paid">paid</option>
                    <option value="cancelled">cancelled</option>
                    <option value="refunded">refunded</option>
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
